import ProfileTableDto from 'app/admin/profile/dto/ProfileTableDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class ProfileTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'profileTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<ProfileTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, ProfileTableDto)))
				.catch(reject);
		});
	}
}

export default new ProfileTableService();
